<template>
  <div>
    <ul class="ts-mx-auto ts-flex ts-space-x-5 ts-items-center" style="width:fit-content">
      <li v-if="model.game_type_id">
        <a href="#" class="ts-bg-gray-300 ts-py-2 ts-px-4 ts-rounded-md ts-text-green-600 ts-cursor-not-allowed">
          <i class="fas fa-random"></i>
        </a>
      </li>
      <li v-for="(d, index) in model.picked_number" :key="index">
        <div
          class="ts-rounded-full ts-h-10 ts-w-10 ts-flex ts-items-center ts-justify-center ts-font-bold ts-text-white ts-text-sm ts-cursor-pointer"
          :class="model.game_type_id == 2 ? 'ts-bg-green-500': 'ts-bg-pink-600'"
          @click.prevent="selectIndex(index)"
        >{{ d.value }}</div>
      </li>
      <li v-if="model.game_type_id">
        <a
          @click.prevent="clearInput"
          href="#"
          class="ts-bg-gray-300 ts-py-2 ts-px-4 ts-rounded-md ts-text-red-600"
        >
          <i class="far fa-times-circle"></i>
        </a>
      </li>
      <li v-if="model.game_type_id">
        <a
          @click.prevent="addToCart"
          href="#"
          class="ts-bg-blue-600 ts-py-2 ts-px-4 ts-rounded-md ts-text-white"
        >
          <i class="fas fa-shopping-cart"></i>
        </a>
      </li>
    </ul>
    <hr class="ts-mt-8" />
    <div class="ts-grid ts-gap-3 ts-grid-cols-10 ts-mx-auto">
      <div
        v-for="(value, num) in generateNumber"
        :key="num"
        class="ts-rounded-full ts-mx-auto ts-h-10 ts-w-10 ts-flex ts-items-center ts-justify-center ts-font-bold ts-text-sm ts-cursor-pointer ts-border ts-border-gray-400 hover:ts-shadow-lg"
        :class="isPicked(num) ? (model.game_type_id == 2 ? 'ts-bg-green-500 ts-text-white': 'ts-bg-pink-600 ts-text-white') : 'ts-text-gray-800'"
        @click.prevent="pickNumber(num)"
      >{{ num }}</div>
    </div>
    <div v-if="model.game_type_id == 2" class="ts-px-8 ts-mt-8">
      <table class="ts-w-full" border="1">
        <tr v-for="(channel, index) in channel_lists" :key="index">
          <td valign="middle" class="ts-w-1/5">
            <p
              class="ts-font-heading-font ts-font-semibold ts-text-base ts-mb-0"
            >{{ channel.game_lot_name }}</p>
          </td>
          <td class="ts-w-1/5">
            <ul class="ts-flex ts-space-x-5 ts-items-center">
              <li v-for="(d, index) in channel.digit_taken" :key="index">
                <div
                  class="ts-rounded-full ts-h-10 ts-w-10 ts-flex ts-items-center ts-justify-center ts-font-bold ts-text-sm ts-cursor-pointer"
                  :class="d == 1 ? 'ts-bg-green-500 ts-text-white': 'ts-bg-gray-300 ts-text-red-600'"
                >{{ d == 1 ? model.picked_number[index].value : 'X' }}</div>
              </li>
            </ul>
          </td>
					<td class="ts-w-1/5 ts-text-right">
						<input 
							type="number"
							style="width:50px"
							class="ts-font-heading-font ts-text-base ts-border ts-text-center ts-rounded-lg ts-py-1 ts-outline-none" 
							v-model.number="channel.multiplier"
							@change="addLine(channel)"
						>
					</td>
        </tr>
      </table>
    </div>
    <hr />
    <div>
      <h5 class="ts-font-semibold ts-font-heading-font ts-text-blue-600">
        {{ $t('gameBetting.amount') }} :
        <span
          class="ts-text-pink-600"
        >{{ model.total_betting_amount }}</span>
      </h5>
    </div>
  </div>
</template>

<script>
export default {
  name: 'pickNumberNew',
  props: ['value', 'gameSet'],
  data() {
    return {
      model: {},
      picked_index: null,
      channel_lists: []
    }
  },
  created() {
    this.model = this.value
  },
  computed: {
    generateNumber() {
      if (this.model.game_type_id == 2) {
        return 10
      } else {
        return 50
      }
    },
    isPicked: vm => num => {
      if (vm.model.picked_number.length > 0) {
        return vm.model.picked_number.filter(e => e.value === num).length
      }
      return false
    }
  },
  methods: {
    createPickNumber() {
      this.model.picked_number = []
      let stop = this.model.game_type_id == 2 ? 4 : 5
      for (var i = 0; i <= stop; i++) {
        this.model.picked_number.push({
          value: ''
        })
      }
    },
    selectIndex(index) {
      this.picked_index = index
    },
    pickNumber(number) {
      if(this.model.game_type_id == 1) {
        const check = _.some(this.model.picked_number, { value: number })
        if (check) {
          // if number already pick
          return
        }
      }
      if (this.picked_index !== null) {
        this.model.picked_number[this.picked_index].value = number
        this.picked_index = null
      } else {
        for (var i = 0; i < this.model.picked_number.length; i++) {
          if (this.model.picked_number[i].value === '') {
            this.model.picked_number[i].value = number
            break
          }
        }
      }
      this.sumTotalAmount()
    },

    clearInput() {
      this.model.total_betting_amount = 0
      this.model.picked_number.forEach(el => {
        el.value = ''
      })
    },
    createChannelList() {
      this.model.betting_detail = []
      this.channel_lists = this.gameSet.game_setting.game_lots.map(
        (el, index) => ({
          game_lot_name: el.game_lot_name,
          game_lot_id: el.game_lot_id,
          betting_amount: el.unit_price,
          digit_taken: el.digit_taken_array,
          multiplier: index == 0 ? 1 : 0 // set multiplier to 1 only jackpot
        })
      )

      // pick jackpot record
      if (this.model.game_type_id == 1) {
        // 4/49
        this.channel_lists.forEach(element => {
          this.model.betting_detail.push(element)
        })
      } else {
        this.model.betting_detail.push(this.channel_lists[0])
      }
    },
    sumTotalAmount() {
      this.model.total_betting_amount = _.sumBy(
        this.model.betting_detail,
        function(o) {
          if (o.multiplier > 0) {
            return o.betting_amount * o.multiplier
          }
          return 0
        }
      )
    },
    // add detail record when multiplier equal to 1
		addLine(game){
			var count = this.model.betting_detail.filter(d => d.game_lot_id == game.game_lot_id).length
			if(count){
				if(!game.multiplier > 0){
					this.model.betting_detail.splice(this.model.betting_detail.indexOf(game), 1)
				}else{
					this.model.betting_detail.filter(d => d.game_lot_id == game.game_lot_id).forEach(el => {
						el.multiplier = game.multiplier
					})
				}
			}
			else
			{
				if(game.multiplier > 0) {
					this.model.betting_detail.push(game)
				}
			}
		},
    addToCart() {
      const check = _.some(this.model.picked_number, { value: '' })
      if (check) {
        return
      }
      this.$parent.$parent.cart.game_set_id = this.model.game_set_id
      this.$parent.$parent.cart.game_type_id = this.model.game_type_id
      let { game_set_id, game_type_id, ...data } = this.model
      this.$parent.$parent.cart.bets.push(_.cloneDeep(data))
      this.clearInput()
      this.createChannelList()
    }
  },
  watch: {
    gameSet: {
      handler() {
        this.createChannelList()
      },
      deep: true
    },
    'model.game_set_id': function(value) {
      if (value) {
        this.createPickNumber()
      }
    }
  }
}
</script>

<style lang="css" scoped>
table {
  border-collapse: collapse;
}
</style>